import React from 'react';
import { bool as boolType, string as stringType, number as numberType } from 'prop-types';
import {
  useDataModel,
  QueryProvider,
} from '@thd-nucleus/data-sources';
import { Col, Row } from '@thd-olt-component-react/grid';
import { getCustomerData } from '../utils/helpers';
import { CategoryCarousel } from '../core/category-carousel/CategoryCarousel';
import { articleGuidesDataModel } from '../dataModel';

const ArticleGuides = (props) => {
  const {
    customerID,
    hideTitle,
    pageType,
    requestKey,
    showLoading,
    slidesPer,
    title
  } = props;
  let custID = customerID;
  const apiName = 'articles';

  if (!custID) {
    // Use svocID if it exists or guestUserId
    const { guestUserID, svocID } = getCustomerData();
    custID = svocID || guestUserID;
  }

  const udsQueryOptions = {
    variables: {
      apiName,
      key: requestKey,
      userId: custID || '',
    },
    ssr: false,
  };

  const { loading, data, error } = useDataModel('uds', udsQueryOptions);

  if (error || (!data?.uds?.articles?.length && !loading)) return null;

  return (
    <Row>
      <Col id={apiName} className="article-guides" data-type="container">
        <meta data-prop="name" content={apiName} />
        <QueryProvider cacheKey="user-data-services-article-guides">
          <CategoryCarousel
            categories={data?.uds?.articles}
            hideTitle={hideTitle}
            loading={loading}
            pageType={pageType}
            placeholderSize="360px"
            showLoading={showLoading}
            title={title}
            /**
            * Note: The componentName prop is responsible for
            * conditional logic that will break if the value doesn't
            * exactly match the hardcoded value in CategoryCarousel.js
            */
            componentName="article-guide"
            hideTextPlaceholder
            breakpoints={{
              sm: {
                slidesPerView: slidesPer || 2,
                slidesPerGroup: slidesPer || 2
              },
              md: {
                slidesPerView: slidesPer || 2,
                slidesPerGroup: slidesPer || 2
              },
              lg: {
                slidesPerView: slidesPer || 3,
                slidesPerGroup: slidesPer || 3
              },
              xl: {
                slidesPerView: slidesPer || 3,
                slidesPerGroup: slidesPer || 3
              }
            }}
            slidesPerView={1}
            slidesPerGroup={1}
          />
        </QueryProvider>
      </Col>
    </Row>
  );
};

ArticleGuides.dataModel = articleGuidesDataModel;

ArticleGuides.displayName = 'ArticleGuides';

ArticleGuides.propTypes = {
  customerID: stringType,
  hideTitle: boolType,
  pageType: stringType,
  requestKey: stringType.isRequired,
  showLoading: boolType,
  slidesPer: numberType,
  title: stringType,
};

ArticleGuides.defaultProps = {
  customerID: null,
  hideTitle: false,
  pageType: null,
  showLoading: false,
  slidesPer: null,
  title: null,
};

export { ArticleGuides };
